import { createAsyncThunk } from '@reduxjs/toolkit'
import { AxiosClient } from 'src/redux/AxiosClient'

export const getSupplierComplianceKpiCardData = createAsyncThunk(
  'alix/get-supplier-compliance-kpi-data',
  async (payload, toolkit) => {
    return await AxiosClient(
      'GET',
      `/v1/risk-management/compliance-scoreboard/kpi?supplierId=${payload.supplierId}&clientId=${payload.clientId}`,
      {},
      toolkit,
    )
  },
)

export const getSupplierComplianceNetwork = createAsyncThunk(
  'alix/get-supplier-compliance-network',
  async (payload, toolkit) => {
    return await AxiosClient(
      'GET',
      `/v1/risk-management/compliance-scoreboard/supplier-network?supplierId=${payload.supplierId}&clientId=${payload.clientId}`,
      {},
      toolkit,
    )
  },
)

export const getSupplierComplianceRiskSummary = createAsyncThunk(
  'alix/get-supplier-compliance-risk-summary',
  async (payload, toolkit) => {
    return await AxiosClient(
      'GET',
      `/v1/risk-management/compliance-scoreboard/compliance-summary?supplierId=${payload.supplierId}&clientId=${payload.clientId}`,
      {},
      toolkit,
    )
  },
)
